import React from 'react'
import { Col, Row } from 'react-bootstrap'
import FileUpload from '../../../components/FileUpload/FileUpload'
import clearIcon from "../../../assets/images/XIcon.svg";
import ContentData from "../../../constants/contentFile.json"
const ProductImageUpload = ({ fileUrl, onImageChange, clearImage, imgError, selectedFile }) => {
  return (
    <Row>
    <div className="adminDetailSection">
      <div className="adminDetailSectionTop roleSubPage">
        <h4>{ContentData.productPage.ProductImage} *</h4>
        <Row className="product-image">
          <Col sm={6} className="product-image-upload">
            <FileUpload
              accept="image/*"
              onChange={onImageChange}
              fileUrl={fileUrl}
              onClearImage={clearImage}
              error={imgError}
            />
          </Col>
          <Col sm={6} className="product-image-preview">
            <div className="preview-container">
              {fileUrl && !imgError ? (
                <>
                  <img
                    src={fileUrl}
                    alt="Preview"
                    style={{
                      maxWidth: "300px",
                      maxHeight: "300px",
                    }}
                  />
                  {fileUrl && (
                    <div className="file-info">
                      <span className="file-name">
                        {selectedFile?.name}
                      </span>
                      <button
                        onClick={clearImage}
                        className="clear-button"
                        aria-label="Remove file"
                      >
                        <img src={clearIcon} alt="clear icon" />
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <div className="no-file">No Image Uploaded</div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </Row>
  )
}

export default ProductImageUpload
